import { HTMLProps } from 'react';
import cx from 'classnames';

import { PlayCircleIcon } from 'components/Icon';

import styles from './LiveEvent.module.scss';

export type PlayAudioProps = Pick<HTMLProps<HTMLDivElement>, 'onClick'> & {};

const PlayAudio = ({ onClick }: PlayAudioProps): JSX.Element => (
  <div className={cx(styles.playAudio, 'd-flex items-center justify-center')} aria-hidden onClick={onClick}>
    <PlayCircleIcon color="#fff" width={70} height={70} />
  </div>
);

export default PlayAudio;
